import React from 'react'
import { createRenderTarget } from '../../render-target'
import { FeatureToggle } from '../../feature-toggling/Toggle/Toggle'
import loadable from '@loadable/component'

export const LazyTaboola = loadable(() => import('./Taboola.web'))

const LazyAmpTaboola = loadable(() => import('./Taboola.amp'))

const TaboolaRender = createRenderTarget('Taboola', {
    web: LazyTaboola,
    amp: LazyAmpTaboola,
    rss: null,
    preview: null,
    app: LazyTaboola,
})

export interface TaboolaProps {
    taboolaContainerId: string
    locationType: TaboolaLocation
    articleId?: string
    ampPosition?: number
}

export const SponsoredTaboola = (props: TaboolaProps) => (
    <FeatureToggle
        feature={'taboola'}
        on={() => <TaboolaRender {...props} />}
    />
)
